export const GET_PAYMENT_REQUEST_PENDING = 'redux-app/paymentRequests/GET_PAYMENT_REQUEST_PENDING';
export const GET_PAYMENT_REQUEST_SUCCESS = 'redux-app/paymentRequests/GET_PAYMENT_REQUEST_SUCCESS';
export const GET_PAYMENT_REQUEST_FAIL = 'redux-app/paymentRequests/GET_PAYMENT_REQUEST_FAIL';
